export const isProd = import.meta.env.VITE_PRODUCTION === "true";
export const isStg = import.meta.env.VITE_STAGING === "true";

// Cloud Functions (asia-northeast1) の呼び出し先 origin。
// 環境判定フラグからのハードコードではなく、接続先 Firebase プロジェクトと
// 常に一致させる（dev2 など同一フラグの別プロジェクトが存在するため）
export const functionsOrigin = `https://asia-northeast1-${
  import.meta.env.VITE_FIREBASE_PROJECT_ID
}.cloudfunctions.net`;
export const tenantHost =
  import.meta.env.VITE_TENANT_HOST?.trim().toLowerCase() ?? "";
export const isTenantHost =
  tenantHost.length > 0 &&
  window.location.hostname.toLowerCase() === tenantHost;

export const DOMAINS = {
  admin: import.meta.env.VITE_ADMIN_DOMAIN,
  app: import.meta.env.VITE_APP_DOMAIN,
  schoolAi: import.meta.env.VITE_SCHOOL_AI_DOMAIN
};
